var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-unit-tips"},[_c('span',[_vm._v(_vm._s(_vm.getCurrUnitTips))])])
}
var staticRenderFns = []

export { render, staticRenderFns }